import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _ArrowRightLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsx("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: _jsx("path", { fill: "currentColor", d: "m20 12 .354-.354.353.354-.353.354zm-15 .5a.5.5 0 0 1 0-1zm9.354-6.854 6 6-.708.708-6-6zm6 6.708-6 6-.708-.708 6-6zM20 12.5H5v-1h15z" }) }) });
}
const ArrowRightLight = forwardRef(_ArrowRightLight);
export { ArrowRightLight };
